{
  "version": 1,
  "asset_id": "aaea3952-915e-4406-950a-0d049356cbc5",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/aaea3952-915e-4406-950a-0d049356cbc5/bahcesehir-hizli-elektrikci-7-24-dukkan-3.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/aaea3952-915e-4406-950a-0d049356cbc5/bahcesehir-hizli-elektrikci-7-24-dukkan-3.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-3.jpg",
  "size": 488445,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:18:44Z"
}
